// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

const config = {
    appId: '41b37380-6905-48ad-8ca5-594bc5ba0d64',
    redirectUri: 'https://atlas.aesara.com',
    scopes: ['user.read', 'Files.Read', 'Files.Read.All', 'Files.Read.Selected'],
}

export default config
